import { Response } from '@/core'
import { PackageBaseParams, PackageApiBuilder, ShipmentSuggestionParams } from './package.api.types'
import {
  AddTicketParams,
  PreSelectTicketParams,
  TicketListParams,
  TicketListResponse,
} from './package.api.tickets.types'

export const ticketsEndpoints = (builder: PackageApiBuilder) => ({
  ticketList: builder.query<Response<TicketListResponse>, TicketListParams>({
    query: ({ eventId, sessionId, modify }) => ({
      url: `/package/event/${eventId}/ticket/list`,
      method: 'get',
      params: { sessionId, modify },
    }),
  }),
  preSelectTicket: builder.mutation<Response<void>, PreSelectTicketParams>({
    query: ({ params, data }: PreSelectTicketParams) => ({
      url: `/package/event/pre-select-ticket`,
      method: 'post',
      params,
      data,
    }),
  }),
  addTicket: builder.mutation<Response<void>, AddTicketParams>({
    query: ({ params, data }: AddTicketParams) => ({
      url: `/package/event/add-ticket`,
      method: 'post',
      params,
      data,
    }),
  }),
  removeTicket: builder.mutation<Response<void>, PackageBaseParams>({
    query: ({ sessionId }) => ({
      url: `/package/event/remove-ticket`,
      method: 'put',
      params: { sessionId },
    }),
  }),
  shipmentSuggestion: builder.mutation<Response<void>, ShipmentSuggestionParams>({
    query: ({ params, data }: ShipmentSuggestionParams) => ({
      url: `/package/event/shipment/suggestion`,
      method: 'post',
      params,
      data,
    }),
  }),
})
